import EventEmitter from 'events';
// import * as Sentry from "@sentry/browser";
// import { Integrations } from "@sentry/tracing";

import QueueManager from './core/QueueManager';

import { API } from './utils/api';
// import { UserConsentManager } from './utils/userConsentManager';

import { createLogger } from './utils/logger';
import {
  IFRAME_IS_NOT_ALLOW_FALLBACK,
  FALLBACK_EVENT_URL,
  APICallMethod,
  Platform,
  event,
  eventAssociator,
  PlayerType,
  ContentType,
  DestroyReason,
  PassbackMode,
  PassbackType,
  PrerollDelayState,
  OnNoAds,
  RANDOM_RUTUBE_CONTENT_URL,
  STREAM_UI_DATA_URL,
  STREAM_START_EVENT_URL,
  STREAM_COMPLETE_EVENT_URL,
  STREAM_RATE_EVENT_URL,
  QueueManagerStatus,
  AdUnitStatus, TagsGroup, FloatingType
} from './utils/const';
import { timeouts } from './utils/options';
import { log, clearAllTimers, injectScript, replaceBaseURLMacroses, logOnServerDebugInfo, isIOS } from './utils/utils';
import { createVastParser } from './utils/parseVast';

const PlatformImports = {
  [PlayerType.SLIDER]: () => import('./core/platforms/slider/Slider'),
  [PlayerType.EMBED]: () => import('./core/platforms/stream/Stream'),
  [PlayerType.STREAM]: () => import('./core/platforms/stream/Stream'),
  [PlayerType.INTERSTITIAL]: () => import('./core/platforms/interstitial/Interstitial'),
  [PlayerType.INPAGE]: () => import('./core/platforms/inpage/Inpage'),
  [PlayerType.FLOATING]: () => import('./core/platforms/floating/Floating'),
}

// function initSentry() {
//   const { tracesSampleRate } = window.viaPlayerCfg || {};
//
//   console.log('initSentry');
//   Sentry.init({
//     dsn: "https://5d0da31a44f244e09a8a26852cdad8ce@o4504198202327040.ingest.sentry.io/4504198203834368",
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       // new Integrations.BrowserTracing(),
//       Sentry.replayIntegration({
//         maskAllText: false,
//         blockAllMedia: false,
//       }),
//     ],
//     allowUrls: ["viadata.store"],
//     ignoreErrors: ["AbortError: The play() request was interrupted by a call to pause()"],
//
//     replaysSessionSampleRate: 1.0,
//     replaysOnErrorSampleRate: 1.0,
//     tracesSampleRate: 1,
//   });
// }

function viaPlayer(config) {
  // console.log('create window.vadsCounter');
  window.vadsCounter = {
    errors: 0,
    impressions: 0,
    attempts: 0,
  };

  const { sid, zone, videoid = 0, container = document.body, callbacks = {} } = config;
  const { onError, onComplete, onStart, onClose } = callbacks;

  // initSentry();

  const onNoAds = () => {
    this.logger.log('onNoAds');

    // this.config.onNoAds = '';
    
    if (this.config.onNoAds === OnNoAds.STOP) {
      this.emitter.emit(event.Player.PlayerDestroyRequest, { reason: this.queue.impressions === 0 ? DestroyReason.NOADS : DestroyReason.OTHER });
    } else {
      if (this.config.onNoAds === OnNoAds.HIDE) {
        this.hiddenDueNoAds = true;
        if (!this.queue.prevActiveUnit || this.queue.prevActiveUnit.config.params.platform !== Platform.YANDEX) {
          this.emitter.emit(event.Player.PlayerVisibilityChangeRequest, false);
        }
        // this.emitter.emit(event.Player.AdStartRequest);
      } else if (!this.config.onNoAds) { //  && this.content.type !== ContentType.STREAM
        const content = this.player.getContent();

        if (this.config.content.type === ContentType.TAGS && !content.isPlaying()) {
          content.play();
        } else {
          if (content && !content.isPlaying() && this.player.isVisible()) content.play();
        }
        
        // isPlayerVisible() && this.emitter.emit(event.Player.ContentStartRequest);
      }

      // if (this.content.type === ContentType.STREAM) {
      //   this.content.setAdsCompleteStatus(true);
      // }

      createNoAdsDelayTimeout();
    }
  }

  const createNoAdsDelayTimeout = () => {
    if (this.runCount >= this.config.MaxRun) { // TODO: code duplication 
      this.logger.log('maxrun');

      if (this.content.type === ContentType.STREAM) {
        this.content.setAdsCompleteStatus(true);
        return;
      }
      clearAllTimers(this.timers);
      this.running = false;
      return this.slot && this.emitter.emit(event.Player.PlayerDestroyRequest, this.impressionCount > 0 ? { reason: DestroyReason.OTHER } : { reason: DestroyReason.NOADS });
    }

    if (this.timers.noAdsDelay) return;
    this.logger.log('noads delay');

    if (this.timers.postInitAd) {
      clearTimeout(this.timers.postInitAd);
      this.timers.postInitAd = null;
    }
    if (this.queue.T2Interval) {
      clearInterval(this.queue.T2Interval);
      this.queue.T2Interval = null;
    }

    this.timers.noAdsDelay = setTimeout(() => {
      this.logger.log('noads timeout');
      this.timers.noAdsDelay = null;
			
      this.queue.onNoAdsDelayed = true;
      this.player.requestNewTags();
      // requestDSPs();
    }, this.config.noadsdelay * 1000 || 0);
  }

  const playNextAd = async () => {
    this.logger.log('play next ad');
    clearTimeout(this.timers.closeFallback);
    this.timers.closeFallback = null;
    
    this.emitter.emit(event.Player.RefreshPlayerCheckAliveTimer, { target: 'before start' });
		this.player.start();
  }

  const getUnitsTag = (tid) => this.tags.find((tag) => tag.tid === tid);

  const logErrorForOutOfQueueUnit = (params) => {
    const unitTag = getUnitsTag(params.tid);

    if (unitTag) {
      const { trackers } = unitTag;

      if (trackers['error']) {
        trackers['error'].forEach((url) => {
          const isViadsTracker = url.includes(this.config.ldom);
          if ((isViadsTracker && this.config.logErrors) || !isViadsTracker) callTrackEventUrl(url);
        });
      }
    }
  }

  const trackEvent = (evt, advID, params) => {
    if (!advID) return this.logger.warn('advID is undefined in trackingEventHandler');

    const eventCaller = this.queue.getUnit(advID);
    if (!eventCaller) {
      if (evt === event.Ad.AdError && params) {
        this.logger.warn(`trying to log out of queue unit with advID ${advID}`);
        return logErrorForOutOfQueueUnit(params);
      } else {
        return this.logger.warn(`cannot find unit with advID ${advID} in queue`);
      }
    }

    if (evt === event.Ad.AdImpression && eventCaller.params.platform === Platform.VPAID && eventCaller.isImpressionEmitted) return;

    let trackingEvent;
    const { trackers, baseTrackers } = eventCaller;

    if (evt === event.Ad.AdVolumeChange) { // uncommon case for mute/unmute;
      if (!this.running) return;
      if (eventCaller.getVolume() === 0) {
        trackingEvent = 'mute';
      } else {
        trackingEvent = 'unmute';
      }
    } else {
      trackingEvent = eventAssociator[evt];
    }

    if (trackingEvent) { // && trackers
      if (evt === event.Ad.AdClickThru && eventCaller.isViralize) return; // ignore click thru events, fired without user interaction // !eventCaller.userInteracted
      // const trackingUrls = trackers[trackingEvent];

      if (baseTrackers && !this.config.ws) {
        const trackingUrls = baseTrackers[trackingEvent];
        
        if (trackingUrls) {
          trackingUrls.forEach((url) => callTrackEventUrl(url)); // /*if (evt !== event.Ad.AdError || (isViadsTracker && this.config.logErrors) || !isViadsTracker) callTrackEventUrl(url); */
        } 
      } else {
        const preparedSocketTrackingData = replaceBaseURLMacroses(`type=player&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=${trackingEvent}&cb=(cb)&vis=(vis)&v=${this.config.playerVersion}`, { sid, zone, tid: eventCaller.params.tid, aid: eventCaller.params.aid, });
        this.socket.send(preparedSocketTrackingData);
      }
        
      if (trackers) {
        const trackingUrls = trackers[trackingEvent];
        
        if (trackingUrls) {
          trackingUrls.forEach((url) => callTrackEventUrl(url)); // /*if (evt !== event.Ad.AdError || (isViadsTracker && this.config.logErrors) || !isViadsTracker) callTrackEventUrl(url); */
        }
      }
    }
  }

  const replaceURLMacroses = (url, useVis = true) => {
    if (!url.includes('(random)') && !url.includes('(cb)') && url.includes('?')) url += "&cbb=(random)";

    const playerWidth = 432; // parseInt(window.top.getComputedStyle(this.slot.parentElement).getPropertyValue(`--${CSS_PREFIX}player-width`)); DEBUG!!!
    const playerHeight = 243; // parseInt(window.top.getComputedStyle(this.slot.parentElement).getPropertyValue(`--${CSS_PREFIX}player-height`)); DEBUG!!!
    // if (useVis) {
    //   if (!url.includes('(vis)') && url.includes(this.config.ldom)) url += '&vis=(vis)';
    //   url = url.replace(/\(vis\)/ig, getElementViewabilityPercent(this.slot.querySelector('.active'), this.currentAd.params.platform));
    // }
    
    let adrcid = 0;
    
    try {
      adrcid = window.localStorage.getItem('adrcid') || 0;
    } catch(e) {}

    return url
      .replace(/\(width\)/ig, playerWidth) // this.slot.clientWidth ||
      .replace(/\(height\)/ig, playerHeight) // this.slot.clientHeight ||
      .replace(/\(region\)/ig, this.config.region)
      .replace(/\(adrcid\)/ig, adrcid)
      .replace(/\(ecode\)/ig, encodeURIComponent(this.lastError))
      .replace(/\(views\)/ig, this.queue.impressions)
      .replace(/\(uuid\)/ig, window.vadsUUID || '') // this.config.uuid
      .replace(/\(consent\)/ig, window.flyGdprConsent || '')
      .replace(/\(tg\)/ig, Math.floor((Date.now() - this.queue.initTimestamp) / 1000))
      .replace(/\(random\)|\(cb\)/ig, Date.now());
  }

  const callTrackEventUrl = (url) => {
    const finalUrl = url.includes(this.config.ldom) ? replaceURLMacroses(url, true) + `&v=${this.config.playerVersion}` : url;
    API.call(finalUrl, {}, { mode: 'no-cors' }, APICallMethod.IMAGE);
  }

  const createSocketConnection = () => {
    if (!this.isBrowserSupportWebsocket) {
      this.config.ws = false;
      return;
    }
    const socket = new WebSocket(`wss://${this.config.ldom}/ws`);

    let keepAliveTimer = null; 
    const keepAlive = () => { 
      if (socket.readyState == socket.OPEN) {  
        socket.send('');  
      }  
      keepAliveTimer = setTimeout(keepAlive, 10000);  
    }

    socket.onopen = (ev) => {
      this.logger.log("connected", ev);

      if (!this.inited && this.config.ws) {
        this.inited = true;
        keepAlive();
        init();
      }
    };
    socket.onmessage = (e) => {
      this.logger.log(`received data`, e);
    };
    socket.onclose = (e) => {
      if (!this.config.ws || !this.socket) return;
      clearTimeout(keepAliveTimer);
      try {
        this.logger.log('connection lost', e);
        this.logger.log('reconnect...');
        this.socket = createSocketConnection();
        this.emitter.emit(event.Player.SocketConntectionUpdate, this.socket);
      } catch (e) {
        this.logger.log('cannot reconnect to socket server: ', e);
        this.config.ws = false;
      }
    }
    socket.onerror = (e) => {
      this.logger.log('socket error', e);
      clearTimeout(keepAliveTimer);
      this.config.ws = false;
 
      if (!this.inited) {
        init();
      }
    }

    return socket;
  }

  const init = async () => {
    // if (!window.Hls && this.config.content.type !== ContentType.PRELOADER && this.config.content.type !== ContentType.NONE) { // TODO: prevent HLS load for ContentType.EMBED
    //   return injectScript(this.config.libHLS, () => init(`intellectual property: 2022664792, inn: 7813616864`));
    // }

    // const b = document.createElement('button');
    // b.innerText = 'display logs';
    // b.style.cssText = 'width: 100%; height: 30px; position: fixed; top: 0; left: 0; z-index: 999999;';
    // b.onclick = () => {
    //   const div = document.createElement('div');
    //   div.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 400px; overflow: auto; background: white; z-index: 999999999';
    //   document.body.appendChild(div)
    //
    //   let str = '';
    //   window.nmlogs.forEach((log) => {
    //     str += log + '<br />';
    //     // try {
    //     //   div.innerHTML += '<p style="margin-bottom: 20px; color: red">' + JSON.stringify(log) +'</p>';
    //     // } catch(e) {
    //     //   div.innerHTML += '<p style="margin-bottom: 20px; color: red">' + log +'</p>';
    //     // }
    //   });
    //   div.innerHTML += (str);
    // }
    // document.body.appendChild(b);

    if (this.config.passbackUrl && this.config.passbackMode === PassbackMode.TOGETHER) {
      injectScript(this.config.passbackUrl);
    }

    PlatformImports[this.config.type]().then(({ Player }) => {
      const parameters = { container, queueManager: this.queue, emitter: this.emitter, config: this.config, logger: this.logger };
      if (this.config.type === PlayerType.EMBED || this.config.type === PlayerType.STREAM) {
        parameters.streamConfig = {
          streamUIDataUrl: replaceURLMacroses(replaceBaseURLMacroses(this.config.type === PlayerType.EMBED ? (RANDOM_RUTUBE_CONTENT_URL + (window.vadsLastID ? `&lid=${window.vadsLastID}` : '')) : STREAM_UI_DATA_URL, { sid, zone, videoid }), false),
          streamTrackingUrls: {
            start: replaceBaseURLMacroses(STREAM_START_EVENT_URL, { sid, zone }),
            complete: replaceBaseURLMacroses(STREAM_COMPLETE_EVENT_URL, { sid, zone }),
            rate: replaceBaseURLMacroses(STREAM_RATE_EVENT_URL, { sid, zone }),
          }
        }
      }

      this.player = new Player(parameters);
    }).catch(error => {
      logOnServerDebugInfo(JSON.stringify({
        timestamp: Date.now(),
        zone,
        sid,
        error: error.message,
        stack: error.stack,
        device: window.navigator.userAgent,
      }), this.config.playerVersion);
    });
  }

  const updateCappingCookie = () => {
    if (this.config.capping && this.config.capping > 0) {
      this.logger.log('update capping cookie', CAPPING_COOKIE_NAME + zone);
      localStorage.setItem(CAPPING_COOKIE_NAME + zone, (new Date()).getTime());
    }
  }

  this.emitter = new EventEmitter();
  this.logger = new EventEmitter(); // TODO: убрать EE, сделав обычным объектом
  this.logger.log = (...args) => {
    this.logger.emit('log', ...args); // if (args[0].includes('_onError') || args[0].includes('_onImpression'))

    // window.nmlogs = window.nmlogs || [];
    // window.nmlogs.push(args);
    // try {
    //   document.body.innerHTML += '<p style="margin-bottom: 20px;">' + JSON.stringify(args) +'</p>';
    // } catch(e) {
    //   document.body.innerHTML += '<p>' + args +'</p>';
    // }
  };
  this.logger.on('log', (...args) => { // TODO: deprecate PlayerLog main emitter event
    if (!this.config.loglevel) return;
    
    return log(`[${zone} | ${this.queue.requests - 1}]`, ...args);
  });
  // this.slot = createPlayerSlot(container, `${CSS_PREFIX}zone-${zone}`);
  this.tagsResponse = null;
  this.content = null;
  this.config = { ...window[CONFIG_VAR_NAME][zone], zone, sid, container }; // vadsPlayerCfg
  this.config.timeouts = { ...timeouts, ...this.config.timeouts };
  this.config.secure = {
    ya: isIOS() || this.config.secure?.ya,
    adman: isIOS() || this.config.secure?.adman,
  };
  this.isBrowserSupportWebsocket = Boolean(window.WebSocket);
  this.socket = this.config.ws ? createSocketConnection() : null;
  this.tags = [];
  // this.pageObserver = new PageObserver();
  this.inited = false;
  this.hiddenDueNoAds = false;
  this.lastError = '';
  this.readyToPlay = true;
  this.waitForEveryTagsCompleteBeforeDestroy = false;
  this.prerollDelayState = PrerollDelayState.IDLE;
  this.impressionCount = 0;
  this.vastParser = createVastParser(replaceURLMacroses, this.emitter, this.config.saveVastContentOnServer, this.config.timeouts.waterfallstart + (this.config.timeouts.waterfallend / 2));
  this.serverLogger = createLogger({ config: this.config, sid, zone, socket: this.socket });
  this.queue = new QueueManager({
    config: this.config,
    emitter: this.emitter,
    logger: this.logger,
    pageObserver: this.pageObserver,
    serverLogger: this.serverLogger,
    vastParser: this.vastParser,
  });
  this.timers = {
    initAd: null,
    postInitAd: null,
    checkVPAIDAlive: null,
    contentFallback: null,
    closeFallback: null,
    finishContentTimeout: null,
    resumeFallback: null,
    waitForEveryTagsCompleteBeforeDestroy: null,
    noAdsDelay: null,
    posterShow: null,
    checkAlive: null,
  };

  this.emitter.on(event.Player.TagCompleteRequest, ({ tid, success }) => this.queue.completeTag(tid, success));

  this.emitter.on(event.Player.TagsRequest, () => {
    if (this.queue && this.queue.requests > 2 && !this.queue.playedInCurrentTagsCycle) return onNoAds();
    if (this.queue.requests >= 2 && this.queue.impressions > 0 && (this.config.type === PlayerType.STREAM || this.config.type === PlayerType.EMBED)) {
      if (!this.queue.ignorePrerollCondition) {
        this.queue.ignorePrerollCondition = true;
      } 
      
      this.queue.status = QueueManagerStatus.CONTENT_PLAYING;
    }
    
    this.player.requestNewTags();
    // requestDSPs();
  });
  this.emitter.on(event.Player.AdPreloaded, (ad) => {
    if (!ad.config) return;

    if (ad) {
      this.queue.addUnit(ad);
      this.queue.queue[TagsGroup.IN_PROCESS].filter(unit => unit !== ad);
      // this.queue = sortAds([...this.queue, ad]);
    }

    setTimeout(() => this.emitter.emit(event.Player.TagCompleteRequest, { tid: ad.config.params.tid, success: true }), 0);
  });
  this.emitter.on(event.Player.AdSkipRequest, () => {
    const { activeUnit } = this.queue;
    
    if (activeUnit && activeUnit.skip) {
      activeUnit.skip();
    }
  });
  // this.emitter.on(event.Player.AdStopRequest, () => {
  //   // const { currentAd } = this;

  //   // if (currentAd && currentAd.stop && this.running) {
  //   //   currentAd.stop();
  //   // }
  // });
  this.emitter.on(event.Player.AdStartRequest, () => {
    // if (this.running && !this.skipingIsInProgress) return;

    playNextAd();
  });
  this.emitter.on(event.Player.QueueManagerStatusChangeRequest, ({ status }) => { // TODO: use emitter for every status change
    this.queue.status = status;
  })
  this.emitter.on(event.Player.AdResizeRequest, ({ width = 432, height = 243 }) => {
    if (this.queue.status === QueueManagerStatus.PLAYING) {
      const { resize } = this.queue.activeUnit;
      if (resize) resize(width, height);
    }
  });
  this.emitter.on(event.Player.ResizeAllAds, ({ width = 432, height = 243 }) => {
    this.queue.queue[0].forEach(unit => {
      if (
        unit.status !== AdUnitStatus.FINISHED &&
        unit.status !== AdUnitStatus.ERROR &&
        unit.status !== AdUnitStatus.INIT &&
        unit.resize
      ) unit.resize(width, height);
    });
  });
  this.emitter.on(event.Player.PlayerDestroyRequest, ({ reason = DestroyReason.OTHER } = {}) => {
    if (reason !== DestroyReason.FORCE_STOP && this.config.type === PlayerType.STREAM) {
      this.logger.log('finished stream ads cycle');
      return;
    }

    this.logger.log(`destroy player`);

    // if (!checkEveryTagsComplete() && reason !== DestroyReason.USER_CLOSE && !this.waitForEveryTagsCompleteBeforeDestroy) {
    //   this.waitForEveryTagsCompleteBeforeDestroy = true;
    //   this.timers.waitForEveryTagsCompleteBeforeDestroy = setTimeout(() => {
    //     this.tags.forEach((tag) => { tag.complete = true; });
    //     this.emitter.emit(event.Player.PlayerDestroyRequest, { reason });
    //   }, 3000);
		//
    //   return;
    // }
		//
    // if (this.content.isPlaying && this.content.isPlaying()) {
    //   this.content.finish();
    // }

    if (this.config.passbackUrl && this.config.passbackType === PassbackType.SCRIPT) {
      if (
        this.config.passbackMode === PassbackMode.ALWAYS ||
        (this.config.passbackMode === PassbackMode.NOADS && reason === DestroyReason.NOADS) ||
        (this.config.passbackMode === PassbackMode.NOCLOSE && reason !== DestroyReason.USER_CLOSE) ||
        (this.config.passbackMode === PassbackMode.ONCLOSE && reason === DestroyReason.USER_CLOSE)
      ) {
        if (this.config.extraEvents && this.config.extraEvents.includes('fallback')) {
          API.call(replaceURLMacroses(replaceBaseURLMacroses(FALLBACK_EVENT_URL, { sid, zone }), false), {}, {}, APICallMethod.IMAGE);
        }

        injectScript(this.config.passbackUrl);
      }
    }

    if (reason === DestroyReason.NOADS && onError) {
      onError({ message: 'no ads' });
    } else if (reason === DestroyReason.USER_CLOSE && onClose) {
      onClose();
    }
    if (onComplete) onComplete();

    // logOnServerDebugInfo(JSON.stringify({
    //   zone,
    //   sid,
    //   reason,
    //   impressions: this.queue.impressions,
    //   requests: this.queue.requests,
    // }), 0);

    if (reason === DestroyReason.USER_CLOSE && this.config.extraEvents && this.config.extraEvents.includes('close')) {
      const url = `https://${this.config.ldom}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=close&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`;

      const isPlaying = this.queue.status === QueueManagerStatus.PLAYING;
      const aid = isPlaying ? this.queue.activeUnit.config.params.aid : 0;
      const tid = isPlaying ? this.queue.activeUnit.config.params.tid : 0;

      const cb = Date.now();
      const tg = Math.floor((Date.now() - this.queue.initTimestamp) / 1000);
      const tu = Math.floor((Date.now() - (isPlaying ? this.queue.activeUnit._startTimestamp : this.queue.tagsResponseTimestamp)) / 1000)
      const views = isPlaying ? this.queue.startAttempts : 0;

      const { sid, zone } = this.config;

      API.call(replaceBaseURLMacroses(url, { tid, aid, sid, zone }).replace('(cb)', cb).replace('(tg)', tg).replace('(tu)', tu).replace('(views)', views), {}, {}, APICallMethod.IMAGE); // TODO: причесать
    }

    this.queue.queue.forEach(group => group.forEach(unit => unit.remove()))
		this.player.destroy({ force: reason === DestroyReason.FORCE_STOP });
  });
  this.emitter.on(event.Player.YandexAdFinished, ({ success = true } = {}) => {
    if (success) this.emitter.emit(event.Player.AdUnitFinished);
  });
  this.emitter.on(event.Player.ContentStartRequest, ({ fullBlock }) => {
    const content = this.player.getContent();
    
    if (content) content.play({ fullBlock }); //  && !content.isPlaying()
  });
  this.emitter.on(event.Player.ContentFinishRequest, ({ keepContentVisible = true } = {}) => {
    return;
    if (this.content.type === ContentType.PRELOADER || this.content.type === ContentType.NONE) return;
    if (this.timers.finishContentTimeout) {
      clearTimeout(this.timers.finishContentTimeout);
      this.timers.finishContentTimeout = null;
    }

    // if (!this.content || !this.content.isPlaying()) return; TODO: debug

    this.content.finish({ keepContentVisible }); // !this.readyToPlay

    // if (!this.readyToPlay) {
    //   this.emitter.emit(event.Player.ContentStartRequest);
    // };
  });
  this.emitter.on(event.Player.ContentFinished, () => {
    if (!this.timers.noAdsDelay) {
      if (!this.player.pageObserver) return (this.queue.status = QueueManagerStatus.READY_TO_PLAY);
      if (this.config.type === PlayerType.EMBED) {
        // this.queue.cleanup();
        return this.emitter.emit(event.Player.TagsRequest);
      }
      this.queue.status = (this.player.pageObserver.playerInView || this.config.floating_mode === FloatingType.ALWAYS) ? QueueManagerStatus.READY_TO_PLAY : QueueManagerStatus.WAIT_FOR_VIEW;
    } else {
      const content = this.player.getContent();
      content.play();
    }
  });
  this.emitter.on(event.Player.PlayerLog, (...args) => {
    if (!this.config.loglevel) return;

    return log(`[${zone}] `, ...args);
  });
  this.emitter.on(event.Player.OnNoAds, () => {
    onNoAds();
  });

  this.emitter.on(event.Ad.AdClickThru, (params) => {
    setTimeout(() => {
      if (this.currentAd.userInteracted || this.currentAd.params.platform !== Platform.VPAID) {
        const { advID, ...clickThruParams } = params;
        const paramsURL = clickThruParams[0]; const playerHandler = clickThruParams[2];
        const resourceURL = paramsURL || this.currentAd.vpaidClickThruURL || '';

        const eventCaller = this.queue.getUnit(advID);
        trackEvent(event.Ad.AdClickThru, advID, eventCaller.params);

        if (playerHandler && resourceURL && API.isURLValid(resourceURL)) {
          window.open(resourceURL);
        }
      }
    }, 0)
  });
  this.emitter.on(event.Ad.AdImpression, ({ advID }) => {
    const eventCaller = this.queue.getUnit(advID);
    if (!eventCaller) return;

    if (!eventCaller.isImpressionEmitted) {
      eventCaller.isImpressionEmitted = true;
    }

    clearAllTimers(this.timers);

    if (this.queue.impressions === 1) {
      updateCappingCookie();

      if (onStart) onStart();
    }
  });
  this.emitter.on(event.Ad.AdVideoStart, ({ advID, unit }) => {
    if (this.destroyingInProcess) return;

    if (this.timers.streamContentFallback) {
      clearTimeout(this.timers.streamContentFallback);
      this.timers.streamContentFallback = null;
    }

    const content = this.player.getContent();
    if (content && unit.config.params.groupId !== TagsGroup.CONTENT) content.finish(); //  && content.isPlaying()
  });
  this.emitter.on(event.Player.SkipPreviewImageChange, (url) => {
    if (this.gui.skipPreview) {
      this.gui.skipPreview.style.backgroundImage = `url(${url})`;
    }
  });

  // if (!document.getElementById(CSS_PREFIX + 'css')) {
  //   createPlayerStyles(this.config.cssPriorityPlace, this.slot); // this.config.tdom
  // }

  if (!this.config.infrm && window.frameElement) {
    const params = {
      ao: encodeURI(JSON.stringify(location.ancestorOrigins))
    };

    API.call(IFRAME_IS_NOT_ALLOW_FALLBACK, params);
    return;
  }

  if (!this.config.ws) init();

  // window.vadsPlayerController = window.vadsPlayerController || {};
  window.vadsPlayerController[zone] = {
    isRunning: () => !this.player.state.destroyed,  // !!document.querySelector(`#${CSS_PREFIX}zone-${zone}`),   && document.querySelector(`#${CSS_PREFIX}zone-${zone}`)
    getPlayerContainer: () => container,
    start: (cfg) => {
      // if (document.querySelector(`.${CSS_PREFIX}player`)) {
      //   this.emitter.emit(event.Player.PlayerDestroyRequest, { reason: DestroyReason.OTHER });
      // }

      new viaPlayer(cfg);
    },
    stop: () => this.emitter.emit(event.Player.PlayerDestroyRequest, { reason: DestroyReason.FORCE_STOP }),
    pause: () => this.emitter.emit(event.Player.AdPauseRequest),
    skip: () => { this.emitter.emit(event.Player.AdSkipped); setTimeout(() => this.emitter.emit(event.Player.AdUnitFinished), 100) },
    __forcePause: () => this.emitter.emit(event.Player.AdPauseRequest, { forced: true }),// this.currentAd && this.currentAd.pause && this.currentAd.pause()
  };

  // const logBtn = document.createElement('button');
  // logBtn.innerText = 'toggle logs for ' + zone + ' zone.';
  // logBtn.onclick = () => { this.config.loglevel = this.config.loglevel ? 0 : 5; }
  // document.body.prepend(logBtn);
}

export default viaPlayer;
